var _rect, _rect2, _rect3, _rect4, _line, _circle, _ellipse, _line2, _line3, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSerumIv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    rx: 16,
    fill: "#f0fdfa"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 40,
    width: 90,
    height: 125,
    rx: 14,
    fill: "white",
    stroke: "#0d9488",
    strokeWidth: 2.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 56,
    width: 56,
    height: 85,
    rx: 8,
    fill: "#ccfbf1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 66,
    width: 36,
    height: 65,
    rx: 5,
    fill: "#99f6e4",
    opacity: 0.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 165,
    x2: 200,
    y2: 215,
    stroke: "#0d9488",
    strokeWidth: 2.5,
    strokeDasharray: "7 4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 220,
    r: 5,
    fill: "#0d9488",
    opacity: 0.6
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 190,
    rx: 4,
    ry: 5,
    fill: "#14b8a6",
    opacity: 0.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 22,
    x2: 200,
    y2: 40,
    stroke: "#94a3b8",
    strokeWidth: 2.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 22,
    x2: 215,
    y2: 22,
    stroke: "#94a3b8",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 262,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#115e59"
  }, "IV Serum Tedavisi")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerumIv);
export default __webpack_public_path__ + "static/media/serum-iv.f439b55108b249d0360716c3d059827f.svg";
export { ForwardRef as ReactComponent };